export const getFacilityIdFromPathname = (pathname: string): string | null => {
  const pattern = /^\/facility\/([^\/]+)/;
  const match = pathname.match(pattern);
  return match ? match[1] : null;
};
